import axios from "axios";
import { app } from "../config";

export const getBaseURL = () => {
  //return "http://3.7.71.61/ssd/backend/index.php/api"

  return "https://api.icarustools.com/ssd/api";

  return `${window.location.protocol}//${window.location.hostname}/ssd/backend/index.php/api`;
};

const api = axios.create({
  baseURL: getBaseURL()
});

export default api;
